export default (state = [], action) => {
  switch (action.type) {
    case "REFRESH_TOKEN_SUCCESS":
      return { ...state,token:action.token };
    case "INVALID_TOKEN_ERROR":
      return {...state}
    default:
      return state;
  }
};
